































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class InputRow extends Vue {
  /**
   * A text label displayed near a row
   */
  @Prop({ type: String })
  private legend!: string;

  /**
   * Whether a row is disabled
   */
  @Prop({ default: false, type: Boolean })
  private disabled!: boolean;
}
